export const TimesStamp = {
  YEAR: 31536000000,
  MONTH: 2592000000,
  WEEK: 604800000,
  DAY: 86400000,
  HOUR: 3600000,
  MINUTE: 60000,
  SECOND: 1000,
};
